import { get } from 'lodash';

import { GEOFENCING_COUNTRY_TO_SHOP_SUPPORT_MAP } from 'constants/geofencing';
import actions from 'state/constants';
import initialState from 'state/initialState';
import { GeofencingUtils } from 'utils/Geofencing';
import Settings from 'utils/Settings';

const fetchGeofencingDataSuccessReducer = (state, action) => {
  const { inferredUserCountry, userSelectedShopID } = action.payload;
  const currentShop = Settings.shopID;
  const alternativeShopID = get(GEOFENCING_COUNTRY_TO_SHOP_SUPPORT_MAP, inferredUserCountry);
  const inferredMismatch = !GeofencingUtils.hasCountrySupport(inferredUserCountry);
  const selectedMismatch = userSelectedShopID !== currentShop;
  const suggestAlternativeShop = !!(inferredMismatch && selectedMismatch && alternativeShopID);

  return {
    ...state,
    inferredUserCountry,
    suggestAlternativeShop,
    alternativeShopID,
  };
};

const fetchGeofencingDataFailureReducer = state => ({
  ...state,
  suggestAlternativeShop: false,
});

const setGeofencingShopSelectionReducer = (state, action) => ({
  ...state,
  suggestAlternativeShop: false,
  userSelectedShopID: action.payload,
});

export const reducer = (state = initialState.geofencing, action) => {
  switch (action.type) {
    case actions.FETCH_GEOFENCING_DATA_REQUEST:
      break;
    case actions.FETCH_GEOFENCING_DATA_SUCCESS:
      return fetchGeofencingDataSuccessReducer(state, action);
    case actions.FETCH_GEOFENCING_DATA_FAILURE:
      return fetchGeofencingDataFailureReducer(state);
    case actions.SET_GEOFENCING_SHOP_SELECTION:
      return setGeofencingShopSelectionReducer(state, action);
    default:
      return state;
  }

  return state;
};

export default reducer;
